export default "__VITE_ASSET__C4jdi_Hd__"